import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ContactPage, Work, Event, Mail, Facebook, Instagram, LinkedIn } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import Main from './Main'
const drawerWidth = 240;

function ResponsiveDrawer(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    var listItems = [
        {
            text: 'About',
            icon: <ContactPage />,
            link: '#about'
        },
        {
            text: 'Portfolio',
            icon: <Work />,
            link: '#portfolio'
        },
        {
            text: 'Blog',
            icon: <Event />,
            link: '#blog'
        },
        {
            text: 'Contact',
            icon: <Mail />,
            link: '#contact'
        },
    ];

    var socialMedia = [
        {
            text: 'Facebook',
            icon: <Facebook />,
            link: 'https://www.facebook.com/weiyefung/'
        },
        {
            text: 'Instagram',
            icon: <Instagram />,
            link: 'https://www.instagram.com/weiye.fung/'
        },
        {
            text: 'Linkedin',
            icon: <LinkedIn />,
            link: 'https://www.linkedin.com/in/weiye-fung-49823987/'
        }
    ];

    const drawer = (
        <div>
            <Toolbar />
            <Divider />
            <List>
                {listItems.map((item) => (
                    <ListItemButton>
                         <ListItem button component='a' href={item.link}>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    </ListItemButton>
                ))}
            </List>
            <Divider />

            <List>
                {socialMedia.map((item) => (
                    <ListItemButton>
                        <ListItem button component='a' href={item.link} target='_blank'>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    </ListItemButton>
                ))}
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        Weiye Fung
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Main />
        </Box>
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default ResponsiveDrawer;
